<div class="container mt-4 mb-4">
    <div class="list-group">

        <a [routerLink]="['/albcode/techblog/toolBox']" class="list-group-item list-group-item-action" aria-current="true">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>ToolBox von AlbCode: Sichere Datenverarbeitung und -validierung</h2>
            </div>
            <p class="mb-1" i18n>Entdecken Sie die ToolBox von AlbCode - Ihre sichere Lösung für Datenverarbeitung und -validierung ohne Datenverlust.</p>
        </a>
        <a [routerLink]="['/albcode/techblog/arc42']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>Effektive Architekturdokumentation mit arc42</h2>
            </div>
            <p class="mb-1" i18n>Einführung in arc42</p>
        </a>
        <a [routerLink]="['/albcode/techblog/lombok']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>Lombok vs. Java Records vs. Native Implementierung: Ein Vergleich</h2>
            </div>
            <p class="mb-1" i18n>Ein detaillierter Vergleich von Lombok, Java Records und nativer Java-Implementierung.</p>
        </a>
        <a [routerLink]="['/albcode/techblog/javaCollections']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>Effiziente Nutzung von Java Collections - Ein umfassender Leitfaden</h2>
            </div>
            <p class="mb-1" i18n>Vertiefen Sie Ihr Verständnis der Java Collections, einschließlich Listen, Sets, Maps und Queues, und lernen Sie, wie Sie sie effizient in Ihren
                Java-Anwendungen einsetzen.</p>
        </a>
        <a [routerLink]="['/albcode/techblog/asciiDoc']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>AsciiDoc und AsciiFlow: Einführung in die Welt der textbasierten Dokumentation und Diagrammerstellung</h2>
            </div>
            <p class="mb-1" i18n>In der Welt der Softwareentwicklung und technischen Dokumentation sind einfache, effiziente Tools unverzichtbar. AsciiDoc und AsciiFlow sind zwei
                solcher Werkzeuge, die es ermöglichen, komplexe Ideen auf einfache und zugängliche Weise darzustellen. In diesem Beitrag werden wir uns eingehend mit AsciiDoc,
                einem textbasierten Dokumentationsformat, und AsciiFlow, einem Tool zur Erstellung von ASCII-Diagrammen, beschäftigen.</p>
        </a>
        <a [routerLink]="['/albcode/techblog/spring']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>Umfassender Leitfaden zu Spring Framework und Spring Boot Annotationen</h2>
            </div>
            <p class="mb-1" i18n>Erhalten Sie einen tiefen Einblick in die Annotationen des Spring Frameworks und Spring Boot. Dieser Leitfaden erklärt jede Annotation und ihre
                Bedeutung in der Java-Entwicklung.</p>
        </a>
        <a [routerLink]="['/albcode/techblog/jakarta']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>Eintauchen in die Welt der Jakarta Bean Validation Constraints</h2>
            </div>
            <p class="mb-1" i18n>Entdecken Sie Jakarta Bean Validation Constraints und wie sie die Datenintegrität in Java-Anwendungen verbessern können. Erfahren Sie mehr über
                eingebaute und benutzerdefinierte Constraints, Best Practices und Integrationstechniken.</p>
        </a>
        <a [routerLink]="['/albcode/techblog/jUnit']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>Migration von JUnit 4 zu JUnit 5 in Java und Spring-Anwendungen</h2>
            </div>
            <p class="mb-1" i18n>Notwendige Migration von JUnit 4 zu JUnit 5 in Java und Spring-Anwendungen. Dieser Leitfaden behandelt alle wichtigen Änderungen, neue Annotations und
                Tipps für eine nahtlose Migration. Ideal für Java-Entwickler, die ihre Testing-Praktiken modernisieren wollen.</p>
        </a>
        <a [routerLink]="['/albcode/techblog/arc42Leitfaden']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>arc42 - Ein Leitfaden für die Erstellung robuster Softwarearchitekturen</h2>
            </div>
            <p class="mb-1" i18n>arc42 ist ein bewährtes Architekturframework, das uns dabei hilft, die Herausforderungen der Softwareentwicklung zu meistern. Mit klaren Vorlagen und
                bewährten Praktiken bietet arc42 eine strukturierte Methode zur Erstellung, Dokumentation und Kommunikation der Architektur.</p>
        </a>
        <a [routerLink]="['/albcode/techblog/requirementsEngineering']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>Die Kunst des Requirements Engineering: Ein Leitfaden für effektive Softwareentwicklung</h2>
            </div>
            <p class="mb-1" i18n>Entdecken Sie die Bedeutung von Requirements Engineering in der Softwareentwicklung. Dieser umfassende Blogbeitrag führt Sie durch die grundlegenden
                Schritte des Anforderungsmanagements, einschließlich Stakeholder-Analyse, Anforderungsdokumentation und -validierung. Erfahren Sie, wie effektives Requirements
                Engineering die Qualität und Effizienz Ihrer Softwareprojekte verbessern kann. Perfekt für Projektmanager, Softwareentwickler und alle, die an der
                Softwarearchitektur interessiert sind.</p>
        </a>
        <a [routerLink]="['/albcode/techblog/uiuxDesignComponent']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>Der Zauber von UI/UX Design</h2>
            </div>
            <p class="mb-1" i18n>Erfahren Sie, warum UI/UX Design so wichtig ist. Entdecken Sie die Bedeutung von Benutzeroberfläche (UI) und Benutzererfahrung (UX) und wie sie
                gemeinsam großartige digitale Produkte schaffen.</p>
        </a>
        <a [routerLink]="['/albcode/techblog/swagger']" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
                <h2 class="h5 mb-1" i18n>Swagger</h2>
            </div>
            <p class="mb-1" i18n>Erfahren Sie mehr über Swagger, das führende Framework für das Design, die Dokumentation und die Entwicklung von RESTful APIs. Dieser Artikel beleuchtet
                die Schlüsselfunktionen von Swagger, seine Vorteile und wie Sie es effektiv in Ihren API-Projekten einsetzen können.</p>
        </a>
    </div>
</div>

<router-outlet name="tb"></router-outlet>